<template>
  <div class="bg-[#FFD602] rounded-xl p-4 w-full text-black font-sans relative">
    <table class="w-full border-collapse">
      <thead>
        <tr class="border-b border-black/20 text-sm font-bold text-left">
          <th class="py-2 px-2 xl:text-[20px]">Họ và tên</th>
          <th class="py-2 px-2 xl:text-[20px]">Số điện thoại</th>
          <th class="py-2 px-2 xl:text-[20px]">Phần quà</th>
          <th class="py-2 px-2 xl:text-[20px]">Thời gian</th>
        </tr>
      </thead>
      <tbody class="text-sm">
      <template v-if="loading">
        <tr class="text-center">
          <td class="pt-3" colspan="4">Đang tải dữ liệu ...</td>
        </tr>
      </template>
      <template v-if="rewards && rewards.length > 0">
        <tr class="border-b border-black/10 last:border-none" v-for="reward in rewards" :key="reward.id">
          <td class="py-3 px-2 xl:text-[16px]">
            <div>{{ reward.name }}</div>
          </td>
          <td class="py-3 px-2 xl:text-[16px]">
            <div>{{ reward.phone }}</div>
          </td>
          <td class="py-3 px-2 xl:text-[16px]">
            <div>{{ reward.prize }}</div>
          </td>
          <td class="py-3 px-2 xl:text-[16px]">
            <div>{{ reward.time }}</div>
          </td>
        </tr>
      </template>
      <template v-if="rewards && rewards.length === 0 && !loading">
        <tr class="text-center">
          <td colspan="4" class="pt-5 text-[16px]">Chưa có dữ liệu</td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TableDesktop',
  props: {
    rewards: {
      type: Array,
      default: () => [],
    },
    typeReward: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style scoped>

</style>